module.exports = __webpack_public_path__ + "static/media/bt0a0da.aebf1159.wav";